<div class="unauthorized"><div class="panel">
  <h1>Access denied</h1>
  <p>{{ auth.accessError() || 'You do not have permission to view this page.' }}</p>
  <button class="act" (click)="retry()" [disabled]="retrying">{{ retrying ? 'Checking…' : 'Reload access' }}</button>
  <button class="act-ghost" (click)="auth.logOut()">Sign out</button>
</div></div>
